module.exports = __webpack_public_path__ + "img/shark.0ae2a71b.png";